'use client';

import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FaFacebookF, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

export const ProductCustomShare = () => {
  const pathname = usePathname();
  const [page, setPage] = useState<{ url: string; title: string } | null>(null);

  useEffect(() => {
    setPage({ url: window.location.href, title: document.title });
  }, [pathname]);

  if (!page) return null;

  const socials = [
    {
      icon: <FaFacebookF size={24} />,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(page.url)}`,
    },
    {
      icon: <FaTwitter size={24} />,
      href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        page.url,
      )}&text=${encodeURIComponent(page.title)}`,
    },
    {
      icon: <FaLinkedin size={24} />,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(page.url)}`,
    },
  ];

  return (
    <div className={cn('', 'ea-product-custom-info__share')}>
      {socials?.map((social, index) => (
        <Link
          key={index}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          className={cn('', 'ea-product-custom-info__share-icon')}
        >
          {social.icon}
        </Link>
      ))}
    </div>
  );
};
